module.exports = __webpack_public_path__ + "img/banner_jpan.8aee9b0.jpg";